import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['vnptPlaceholder']

  startVerify() {
    // this.vnptPlaceholderTarget.src = "https://app.lvh.me:3000/vnpt/"
  }
}
